import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import { useEntityTypeFilter } from '../../hooks/useEntityTypeFilter.esm.js';
import { useApi, alertApiRef } from '@backstage/core-plugin-api';
import { Select } from '@backstage/core-components';
import { catalogReactTranslationRef } from '../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

const EntityTypePicker = (props) => {
  const { hidden, initialFilter } = props;
  const alertApi = useApi(alertApiRef);
  const { error, availableTypes, selectedTypes, setSelectedTypes } = useEntityTypeFilter();
  const { t } = useTranslationRef(catalogReactTranslationRef);
  useEffect(() => {
    if (error) {
      alertApi.post({
        message: t("entityTypePicker.errorMessage"),
        severity: "error"
      });
    }
    if (initialFilter) {
      setSelectedTypes([initialFilter]);
    }
  }, [error, alertApi, initialFilter, setSelectedTypes, t]);
  if (availableTypes.length === 0 || error) return null;
  availableTypes.sort(
    (a, b) => a.toLocaleLowerCase("en-US").localeCompare(b.toLocaleLowerCase("en-US"))
  );
  const items = [
    { value: "all", label: t("entityTypePicker.optionAllTitle") },
    ...availableTypes.map((type) => ({
      value: type,
      label: type
    }))
  ];
  return hidden ? null : /* @__PURE__ */ jsx(Box, { pb: 1, pt: 1, children: /* @__PURE__ */ jsx(
    Select,
    {
      label: t("entityTypePicker.title"),
      items,
      selected: (items.length > 1 ? selectedTypes[0] : void 0) ?? "all",
      onChange: (value) => setSelectedTypes(value === "all" ? [] : [String(value)])
    }
  ) });
};

export { EntityTypePicker };
//# sourceMappingURL=EntityTypePicker.esm.js.map
